function updateTotalPrices() {
  let totalPrice = 0;
  let totalRetailPrice = 0;
  let includesTax = false;


  $('.product__display-price:not(.total-price-flag)').each(function() {

    // Is this included?
    let toggleButton = $(this).closest('.product__inside__hover').find('.optional-bracket button');
    if (toggleButton.length > 0) {
      if (!toggleButton.hasClass('button--secondary')) {
        return;
      }
    }


    // Add to the total price
    let price = parseFloat($(this).text().replace(/\$|,|Trade: |Retail: /g, ''));

    if (price) {
      if ($(this).text().substring(0, 7) === 'Retail:') {
        totalRetailPrice += price;
      } else {
        totalPrice += price;
      }

      let conditions = $(this).next('.product__display-price-conditions');
      if (conditions && conditions.text().indexOf('GST') > -1) {
        includesTax = true;
      }
    }
  });

  let formattedTotalPrice = totalPrice
    .toLocaleString('en-US', {
      style: 'currency',
      currency: 'AUD'
    })
    .replace(/A/g, '');

  let formattedTotalRetailPrice = totalRetailPrice
    .toLocaleString('en-US', {
      style: 'currency',
      currency: 'AUD'
    })
    .replace(/A/g, '');

console.log(formattedTotalPrice);
console.log(formattedTotalRetailPrice);
  
  if (totalRetailPrice) {
    $('.total-price .price-box__current .product__display-price').text('Trade: ' + formattedTotalPrice);
    $('.total-price .price-box__current .product__display-price-conditions').text(includesTax ? 'AUD inc GST' : 'AUD Excl. Goods & Services Tax');
    $('.total-price .price-box__old .product__display-price').text('Retail: ' + formattedTotalRetailPrice);
    $('.total-price .price-box__old .product__display-price-conditions').text(includesTax ? 'AUD inc GST' : 'AUD Excl. Goods & Services Tax');

  } else {
    $('.total-price .price-box__current .product__display-price').text(formattedTotalPrice);
    $('.total-price .price-box__current .product__display-price-conditions').text(includesTax ? 'AUD inc GST' : 'Excl. Goods & Services Tax');
    $('.total-price .price-box__current .product__display-price-conditions').text((!includesTax && userCountry === 'NZ') ? 'NZD Excluding GST' : 'AUD inc GST');
    $('.total-price .price-box__old .product__display-price').text('');
    $('.total-price .price-box__old .product__display-price-conditions').text('');
  }

  $('.total-price .fineprint').text(includesTax ? '*Shipping & Installation not included.' : '*Shipping & Installation not included.');
}

function queueUpdateTotalPrices() {
  if (!window.actionQueueComplete) {
    window.actionQueue.push({
      action: 'updateTotalPrices'
    });
  } else {
    updateTotalPrices();
  }
}


$(document).ready(function() {

  // Queue for the collection total to be updated on page load
  // NOTE: We assume that the other pricing updates are already queued and not added inside a $(document).ready(function () {});
  queueUpdateTotalPrices();


  // Update the kit when changing products
  $('.optional-bracket-button').on('click', function(e) {
    e.preventDefault();

    $(this).toggleClass('button--secondary');
    $(this).text($(this).hasClass('button--secondary') ? 'Remove Bracket' : 'Add bracket');

    queueUpdateTotalPrices();
  });


  // "Request Quote" button
  $('.button-request-a-quote').on('click', function(e) {
    e.preventDefault();

    Object.values(GRFQCollection).forEach((product, index) => {
      if (index == 0) {
        GRFQApp.add($('.rfq_btn_total'), product.id);
      } else {
        const sku = product.variants[0].id;
        if (
          $(`.optional-product-sku-${sku}`).length === 0 ||
          $(`.optional-product-sku-${sku}`).hasClass('fa-check-square-o')
        ) {
          var quote_id = GRFQ_getCookie(GRFQConfigs.shop_url + 'quote.id');
          var check = false;
          var ga_interval = setInterval(checkApp, 1000);

          function checkApp() {
            if (parseInt(GRFQ_getCookie(GRFQConfigs.shop_url + 'quote.id')) > 0) {
              check = true;
              clearInterval(ga_interval);
            }
            if (check) {
              GRFQApp.add($('.rfq_btn_total'), product.id);
            }
          }
        }
      }
    });
  });


  //
  // TODO: Add to cart for dealers
  //

  let variant_id = 0;
  $(document).on('click', '.addtocart-acsearch', function() {
    let ac_search_items = [];
    variant_id = $(this).attr('data-value');
    $('.acsku').each(function() {
      const sku = $(this).attr('data-value');
      if ($(`.optional-product-sku-${sku}`).length === 0 || $(`.optional-product-sku-${sku}`).hasClass('fa-check-square-o')) {
        ac_search_items.push({
          quantity: 1,
          id: sku
        });
      }
    });
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: { items: ac_search_items },
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        } else {
          Shopify.cartPopap(variant_id);
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    };
    $.ajax(params);
  });


});
